import React from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { FieldGroup, Grid, PhoneInput, Stack, Text, TextInput } from 'library/ui';
import FormSection from './FormSection';

interface PersonalInfoSectionProps {
    firstName: string;
    setFirstName: (value: string) => void;
    lastName: string;
    setLastName: (value: string) => void;
    phoneDisplay: string;
    onPhoneChange: (value: string, display: string) => void;
    phoneError: boolean;
    phoneErrorText: string;
    expanded: boolean;
    complete: boolean;
    onToggle: () => void;
    onNext: () => void;
}

export default function PersonalInfoSection({
    firstName,
    setFirstName,
    lastName,
    setLastName,
    phoneDisplay,
    onPhoneChange,
    expanded,
    complete,
    onToggle,
    onNext,
}: PersonalInfoSectionProps) {
    return (
        <FormSection
            title="Personal Information"
            icon={<PersonIcon />}
            expanded={expanded}
            complete={complete}
            onToggle={onToggle}
            onNext={onNext}
            autoFocusId="signup-first-name"
        >
            <Stack gap="md" fullWidth>
                <Grid minColumnWidth={200} gap="md">
                    <FieldGroup label="First Name*">
                        <TextInput id="signup-first-name" value={firstName} onChange={setFirstName} fullWidth />
                    </FieldGroup>
                    <FieldGroup label="Last Name*">
                        <TextInput id="signup-last-name" value={lastName} onChange={setLastName} fullWidth />
                    </FieldGroup>
                </Grid>
                <Stack gap="sm">
                    <FieldGroup label="Phone*">
                        <PhoneInput id="signup-phone" value={phoneDisplay} onChange={onPhoneChange} fullWidth />
                    </FieldGroup>
                    <Text size="sm" tone="secondary">
                        We recommend using a mobile number.
                    </Text>
                </Stack>
            </Stack>
        </FormSection>
    );
}
